import React from "react";
import {
  Modal,
  Container,
  Row,
  Col
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import classes from "./JurisprudenceModal.module.css";
import CloseButton from '../UI/CloseButton/CloseButton';

const JurisprudenceModal = (props: any) => {
  const { t } = useTranslation();
  const [data, setData] = React.useState<IActiveJurisprudenceModal|null>(null);

  React.useEffect(() => {
    if (props.show) {
      setData({
        ...props
      })
    }
  }, [props]);

  return (
    <Modal centered show={props.show} onHide={() => props.setShow(false)} size="lg">
      <Modal.Header className={classes.header}>
        <CloseButton onClick={() => props.setShow(false)} />
        <Modal.Title>{t("jurisprudence_datasheet")}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={classes.body}>
        <Container>
          <Row>
            <Col md="3" className="mb-1">{t("title")}</Col>
            <Col md="9">{data?.title}</Col>

            <Col md="3" className="mb-1">{t("decision_date")}</Col>
            <Col md="9">{data?.decision_date}</Col>

            <Col md="3" className="mb-1">{t("outcome")}</Col>
            <Col md="9">{data?.outcome}</Col>

            <Col md="3" className="mb-1">{t("article")}</Col>
            <Col md="9">{data?.article}</Col>

            <Col md="3" className="mb-1">{t("subheading")}</Col>
            <Col md="9">{data?.subheading}</Col>

            <Col md="3" className="mb-1">{t("denomination")}</Col>
            <Col md="9">{data?.denomination}</Col>

            <Col md="3" className="mb-1">{t("species_name")}</Col>
            <Col md="9">{data?.species_name}</Col>

            <Col md="3" className="mb-1">{t("description")}</Col>
            <Col md="9" dangerouslySetInnerHTML={{__html: data?.description?data?.description?.replace(/\n/g,"<br>"):""}} />
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
};

export interface IActiveJurisprudenceModal {
  title?: string;
  decision_date?: string;
  outcome?: string;
  article?: string;
  subheading?: string;
  denomination?: string;
  species_name?: string;
  description?: string;
}

export default JurisprudenceModal;
